export default __webpack_public_path__ + "static/media/E5.3206eaf4.jpg";